import { render, staticRenderFns } from "./IconCirclePoint.vue?vue&type=template&id=5aa5cbe4"
import script from "./IconCirclePoint.vue?vue&type=script&lang=js"
export * from "./IconCirclePoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports